import { DialogService, GridAction } from '@eforall/dashboard';
import { AccVentureDialog } from '../../../../../../../ui/widget';
import { AcceleratorAreaService } from '../.././../../accelerator-area.service';
import { Graduation } from '../graduation-view.part';

export function getActions(dialogService: DialogService, accAreaService: AcceleratorAreaService) {

	const actions: GridAction<Graduation>[] = [
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'Open Venture',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				const accVentureId = rows[0]?.accVentureId;
				if (accVentureId) {
					await dialogService.showCustom(AccVentureDialog, { data: { accVentureId } }, 900, 700);
					await accAreaService.reloadData(); // TODO: optimize to reload only if changes were made
				}
			}
		},
	];

	return actions;
}